<template>
    <div class="side-bar-default pointer-up">
        <!-- Alert Message (validation) //-->
        <alert-message v-if="$attrs.context.showAlert" :message="$attrs.context.alertMessage" />

        <!-- Info message //-->
        <div v-if="$attrs.context.showInfoMessage" class="info">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <p>{{ $attrs.context.infoMessage }}</p>
        </div>

        <!-- Thumbnail //-->
        <div class="item-info" v-if="$attrs.context.selectedItem">
            <div class="gallery-thumb-container" :class="`${$attrs.context.selectedItem.type}-thumb-container`">
                <thumbnail :item="$attrs.context.selectedItem" />
            </div>
            <div class="item-info-title">
                <strong>{{ $attrs.context.selectedItem.title }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
import AlertMessage from '@/components/alert-message';
import Thumbnail from '@/components/media/Thumbnail';

export default {
    name: 'SideBarDefault',
    components: {
        AlertMessage,
        Thumbnail,
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.side-bar-default {

    position: relative;
    overflow: visible;

    &.pointer-up:before {
        content: '';
        position: absolute;
        top: -15px;
        right: 55px;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid map-get($ca-branding, 'primary');
        z-index: 999;
    }

    .item-info {
        display: flex;
        flex-direction: column;
        justify-content: center;

        margin: 0; // override ca.css

        &-title {
            margin-top: 1rem;
        }
    }
}
</style>
